<template>
  <div class="fill-height">
    <v-card class="fill-height">
      <v-card-title class="p-1">
        <v-chip
            label small
            class="ma-2"
            color="secondary">
          حساب ها
        </v-chip>
        <v-spacer/>
        <v-btn light icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text>
        <v-row v-if="userType!=='user'">
          <v-col cols="12" sm="3">
            <v-autocomplete
                :items="buildingList"
                v-model="buildingId"
                @input="handleInput"
                dense
                outlined
                :error-messages="getError('buildingId')"
                auto-select-first append-icon="fas fa-angle-down"
                label="انتخاب مجتمع"

            />
          </v-col>
          <v-col cols="12"
                 sm="3"
                 class="d-inline-flex"
          >
            <v-text-field
                outlined
                dense
                placeholder="نام واحد یا نام شخص "
                v-model="searchvalue"
            />
            <v-btn fab small color="primary" @click="search" class="mr-1">
              <v-icon>mdi-cloud-search</v-icon>
            </v-btn>

          </v-col>
          <v-col cols="12"
                 sm="12" md="6" class="d-inline-block">
            <b-pagination
                v-model="skip"
                :total-rows="paging.totalSize"
                :per-page=take
                first-text="اولین"
                prev-text="<"
                next-text=">"
                last-text="آخرین"
                dir="ltr"
                limit="5"
                @change="pageChangeHandler"
            />
          </v-col>
        </v-row>


        <edit-account :user-type="userType" :model="model" :dialogStatus.sync="showDialog"/>

        <v-spacer/>
        <v-row>
          <v-col cols="12">
            <v-alert type="warning" class="justify-center" dense light>
              حساب‌ها در حال به‌روزرسانی و تست هستند؛ لطفاً تا نهایی شدن فرآیند، به اطلاعات نمایش‌داده‌شده استناد نکنید.
            </v-alert>
          </v-col>

<!--          <v-col cols="12" md="3" sm="4" class="mb-2" v-if="can('updateAccount')">-->
<!--            <v-btn depressed small color="success" @click="updateAccount(false)">-->
<!--              به روزرسانی حساب ها (استورم)-->
<!--            </v-btn>-->
<!--          </v-col>-->
          <v-col cols="12" md="3" sm="4" class="mb-2" v-if="can('updateAccount')">
            <v-btn depressed small color="success" @click="updateAccount(true)">
              به روزرسانی حساب (8ta8)
            </v-btn>
          </v-col>
        </v-row>
        <v-spacer/>
        <v-row>
        <v-card-text>
          <b-table
              sticky-header="500px"
              v-if="can('accountList')"
              :items="dataItems"
              :fields="columns"
              :current-page="skip"
              :per-page=0
              show-empty
              striped
              style="font-size: 13px;color: black ;width: 100%;">

            <template #cell(sumRemainder)="row">
            <span v-if="row.item.sumRemainder && row.item.sumRemainder.includes('-')"
                  style="color: red">{{ row.item.sumRemainder }}</span>
              <span
                  v-else>{{
                  row.item.sumRemainder
                }}</span>
            </template>
            <template #cell(actions)="row">
              <v-btn depressed small v-if="can('detailAccount')" color="primary" @click="goDetail(row.item)"
                     class="mr-1 ">
                جزئیات
              </v-btn>
              <v-btn depressed small v-if="row.item.hasOnlinePayment" color="success"
                     :to="{path:'/payment' ,query:{id:row.item.id}}" class="mr-1 ">
                پرداخت آنلاین
              </v-btn>

            </template>
            <template #cell(tenant)="row">
              <v-switch disabled dense v-model="row.item.tenant"/>
            </template>
            <template #cell(owner)="row">
              <v-switch disabled dense v-model="row.item.owner"/>
            </template>
          </b-table>
        </v-card-text>
        </v-row>

      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import EditAccount from './PageEdit'
import Account_se from "./Account_se";
import {mapMutations} from "vuex";

const stabilityStatus = Object.freeze({
  based: "مستقر است",
  leave: "ترک کرده",
  empty: "خالی است"
});
export default {
  name: 'account',
  components: {
    EditAccount,
  },
  data() {
    return {
      stabilityStatus,
      searchvalue: '',
      modelId: '',
      userType: '',
      model: {},
      selected: [],
      showDialog: false,
      newDialog: false,
      modelAtributes: {},
      dataItems: [],
      buildingId: '',
      buildingList: [],
      bindingErrors: [],
      paging: {},
      skip: 1,
      take: 10,
      currentPage: 1,
      columns: [
        {key: 'buildingName', label: 'مجتمع', sortable: true, sortDirection: 'desc'},
        {key: 'unitName', label: 'نام واحد',},
        {key: 'fullName', label: 'نام شخص',},
        {key: 'stabilityText', label: 'وضعیت واحد',},
        {key: 'sumCreditor', label: 'جمع پرداختی واحد (ریال)',},
        {key: 'sumDebtor', label: 'جمع بدهی واحد (ریال)',},
        {key: 'sumRemainder', label: 'مانده (ریال)', sortable: true, sortDirection: 'desc'},
        {key: 'owner', label: 'مالک'},
        {key: 'tenant', label: 'مستأجر',},
        // {key: 'lastUpdateText', label: 'تاریخ بروز رسانی(استورم)',},
        {key: 'lastUpdatePanelText', label: 'تاریخ بروز رسانی(پنل)',},
        {key: 'actions', label: 'عملیات'}
      ],

    };

  },

  mounted() {
    this.$root.$on('Account', () => {
      this.search()
    })

  },

  methods: {
    close() {
      this.searchvalue = ""
      this.$root.$emit('Account')
      this.$router.push('/home')
    },
    ...mapMutations({
      setDrawer: 'SET_DRAWER',
      setMini: 'SET_MINI',
    }),
    handleInput(value) {
      this.$emit('input', value)
    },
    getError(key) {
      if (this.bindingErrors && this.bindingErrors.length > 0) {
        let error = this.bindingErrors.find(({fieldName}) => fieldName === key);
        if (error && error.message) return error.message[0]
      }
      return ''
    },

    updateAccount(isPanel) {
      this.$progress({message: 'درحال به روزرسانی حساب ها...'}, true)
      Account_se.updateAccount(this.buildingId, isPanel).then(response => {
        if (response && response.status === 200) {
          this.$root.$emit('Progress')
          this.fillDataItems()
          this.$snack({type: 'success'})
        } else if (response && response.status === 408) {
          this.$root.$emit('Progress')

        } else if (response && response.response.status === 400) {
          this.$root.$emit('Progress')
          this.loading = false
          this.bindingErrors = response.response.data;
        }
      })

    },

    goDetail: function (e) {
      this.modelId = e.id;
      this.$router.push({name:"DetailAccount",query:{id:e.id}})

    },

forEdit: function (e) {
      this.modelId = e.id;
      Account_se.getDetails(this.modelId, false).then(response => {
        this.model = response.data
      })
      this.showDialog = true;
    },


    pageChangeHandler: function (event) {
      this.skip = event;
      this.fillDataItems();

    },

    fillDataItems() {
      Account_se.getPage(this.searchvalue, this.buildingId, this.skip - 1, this.take).then(response => {
        this.paging = response.data.page
        this.userType = response.data.userType
        this.dataItems = response.data.accountList
        this.buildingList = response.data.buildingItems
      });
    },

    search() {
      this.skip = 1
      this.take = 10
      this.fillDataItems()
    }


  },

  created() {
    this.setDrawer(false)
    this.fillDataItems();
  }

}
</script>

<style>
.table th, .table td {
  padding: 5px !important;
}

</style>
<style scoped>
::v-deep th {
  white-space: nowrap;
}

::v-deep td {
  white-space: nowrap;
}
</style>